
import { filtersDTO, NotThirdPartyResponseDTO, NotThirdPartyDataDTO, NotThirdPartyProcessingResponseDTO, NotThirdPartyStructureResponseDTO, NotThirdPartyProcessingCreateDTO } from "./dto";
import { NotProductiveUnitImpl } from "./serviceImpl";

export interface NotThirdPartyService {
    GetAllNotThirdParty(filters: filtersDTO): Promise<NotThirdPartyResponseDTO>
    GetAllNotThirdPartyProcessing(filters: filtersDTO): Promise<NotThirdPartyProcessingResponseDTO>
    GetAllNotThirdPartyStructure(filters: filtersDTO): Promise<NotThirdPartyStructureResponseDTO>
    CreateProcessing(body: NotThirdPartyProcessingCreateDTO): Promise<void>
}

export function NewNotThirdPartyService(): NotThirdPartyService {
    return new NotProductiveUnitImpl()
}